module.exports = "pegasus/assets/background-patterns/tech_theme.gif";